import {
  UIAtolProtectedStatus,
  UICampaignBanner,
  UICarrierBaggagePolicies,
  UIClientFetchError,
  UIFetchStatus,
  UIFlightData,
  UISearchCabinClassExtension,
  UISearchDisplayOptions,
  UISearchMinPriceInfo,
  UISearchResultsAggregation,
  UISearchResultsBanner,
  UISearchResultsFlightDeal,
  UISearchResultsSearchCriteria,
  UISegmentationKey,
  UISubsidizedFaresSummary,
  UISortingOption,
  UIPersonalisationParameters
} from "@flights/types";

export type State = {
  [x: string]: any;
  campaignBanner?: UICampaignBanner;
  fetchStatus: UIFetchStatus;
  flights: UIFlightData[];
  atolProtectedStatus?: UIAtolProtectedStatus;
  availableFilters: UISearchResultsAggregation;
  subsidizedFaresSummary: UISubsidizedFaresSummary;
  cabinClassExtension?: UISearchCabinClassExtension;
  baggagePolicies?: UICarrierBaggagePolicies[];
  error?: UIClientFetchError;
  flightDeals?: UISearchResultsFlightDeal[];
  searchCriteria?: UISearchResultsSearchCriteria;
  searchId?: string;
  displayOptions?: UISearchDisplayOptions | null;
  sortingOptions?: UISortingOption[] | null;
  banners?: UISearchResultsBanner[];
  personalisationSegments?: UISegmentationKey[];
  flexPrice?: UISearchMinPriceInfo[]; // flights_web_sr_new_flex_price_ml_model
  flexPriceWebVariant?: number; // flights_web_sr_new_flex_price_ml_model
  personalisationAttributes?: UIPersonalisationParameters;
};

export const getInitialState = (): State => ({
  fetchStatus: "initial",
  flights: [],
  availableFilters: {},
  subsidizedFaresSummary: [],
  error: undefined,
  campaignBanner: undefined,
  searchCriteria: undefined,
  searchId: undefined,
  displayOptions: undefined,
  sortingOptions: undefined,
  flexPrice: [], // flights_web_sr_new_flex_price_ml_model
  flexPriceWebVariant: 0, // flights_web_sr_new_flex_price_ml_model
  banners: undefined
});
